import { Card, CardBody, CardHeader, CardTitle, ProgressBar } from '@ludus/ui'
import { useTranslation } from 'react-i18next'
import { useStageFunnels } from '../../data/usePipelinesSource.ts'
import { FunnelPill } from '@/shared/components/FunnelPill.tsx'

interface ByFunnelProps {
  totalLeadsInStage: number
}

export function ByFunnel({ totalLeadsInStage }: ByFunnelProps) {
  const { t } = useTranslation()
  const funnels = useStageFunnels()

  return (
    <Card className="rounded-xl border-border shadow-none">
      <CardHeader className="border-border/20 py-2.5">
        <CardTitle className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted">
          {t('pages.pipelines.side.byFunnel', { defaultValue: 'By funnel' })}
        </CardTitle>
      </CardHeader>
      <CardBody className="flex flex-col gap-2.5 py-3">
        {funnels.length === 0 && (
          <span className="text-xs text-muted">
            {t('pages.pipelines.side.empty', { defaultValue: 'Nothing to show.' })}
          </span>
        )}
        {funnels.map((f) => {
          const pct =
            totalLeadsInStage === 0 ? 0 : Math.round((f.leadCount / totalLeadsInStage) * 100)
          return (
            <div key={f.key} className="flex flex-col gap-1.5">
              <div className="flex items-center gap-2">
                <FunnelPill abbr={f.abbr} label={f.label} />
                <span className="flex-1 truncate text-sm text-foreground">{f.label}</span>
                <span className="font-mono text-sm font-semibold tabular-nums text-foreground">
                  {f.leadCount}
                </span>
              </div>
              <ProgressBar value={pct} tone="primary" size="sm" />
            </div>
          )
        })}
      </CardBody>
    </Card>
  )
}
